module.exports = __webpack_public_path__ + "img/ImageBackground1.fd0f4524.png";